export default __webpack_public_path__ + "initiative.c044d08.png";